import { render, staticRenderFns } from "./LeagueThirdScreen.vue?vue&type=template&id=7fd71fb3&scoped=true"
import script from "./LeagueThirdScreen.vue?vue&type=script&lang=js"
export * from "./LeagueThirdScreen.vue?vue&type=script&lang=js"
import style0 from "./LeagueThirdScreen.vue?vue&type=style&index=0&id=7fd71fb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd71fb3",
  null
  
)

export default component.exports